import React, { useState, useCallback } from 'react';

import { Modal } from '../../../components/Modal/Modal.component';
import { ExaminerFunction } from '../../Assessment/Assessment.types';
import { SessionsParametersDialogContent } from './SessionsParametersDialogContent/SessionsParametersDialogContent.component';
import { useTranslation } from 'react-i18next';

interface SessionsParametersDialogProps {
  xCloseButton: (isDataChanged: boolean) => void;
  onClose: () => void;
  open: boolean;
  sheetId: string;
  id: string;
  title: string;
  activeTab: string;
  isSheetConfigured: boolean;
  isExaminerView?: boolean;
  examinerFunction?: ExaminerFunction;
  isControlProcessActive?: boolean;
  isQualificationProcessActive?: boolean;
  refresh?: () => void;
}

export const SessionsParametersDialog: React.FC<SessionsParametersDialogProps> = ({
  xCloseButton,
  onClose,
  open,
  sheetId,
  id,
  title,
  activeTab,
  isExaminerView,
  isSheetConfigured,
  examinerFunction,
  isControlProcessActive,
  isQualificationProcessActive,
  refresh,
}) => {
  const [isContentChanged, setIsContentChanged] = useState<boolean>(false);

  const { t } = useTranslation();

  const handleChangeContent = useCallback((isDataChanged: boolean) => setIsContentChanged(isDataChanged), []);

  return (
    <Modal
      xCloseButton={() => xCloseButton(isContentChanged)}
      id={id}
      open={open}
      size="xl"
      heightReducing
      title={`${t('sessionsParameters:tabLabels:title')} ${title}`}
    >
      <SessionsParametersDialogContent
        sheetId={sheetId}
        onClose={onClose}
        onCancel={() => xCloseButton(isContentChanged)}
        onChange={handleChangeContent}
        activeTab={activeTab}
        isExaminerView={isExaminerView}
        isSheetConfigured={isSheetConfigured}
        examinerFunction={examinerFunction}
        isControlProcessActive={isControlProcessActive}
        isQualificationProcessActive={isQualificationProcessActive}
        refresh={refresh}
      />
    </Modal>
  );
};
